<template>
	<div :class="excelUseYn === 'true' ? datatable.class : `datatablehover2 ${datatable.class}`" class="datatablehover">
		<v-data-table
			calculate-widths
			show-current-page
			:fixed-header="datatable.header_fixed"
			:headers="datatable.headers"
			:items="datatable.items"
			:hide-default-footer="datatable.hidedefaultfooter"
			:page.sync="datatable.page"
			:items-per-page.sync="datatable.itemPerPage"
			@page-count="datatable.pageCount = $event"
			:show-select="datatable.showselect"
			:search="search"
			@click:row="$emit('click', $event)"
			@pagination="$emit('pagination', $event)"
			:height="datatable.height"
			:mobile-breakpoint="datatable.breakpoint ? '1960' : '0'"
			:disable-sort="datatable.disableSort"
			:class="datatable.disableSort ? 'noSort' : ''"
			:footer-props="{
				['items-per-page-text']: `• Total : ${datatable.items.length}`,
				['page-text']: ` 1 - ${
					datatable.itemPerPage ? Math.ceil(datatable.items.length / datatable.itemPerPage) : Math.ceil(datatable.items.length / 10)
				} of ${datatable.page ? datatable.page : 1} `,
			}"
		>
			<template v-slot:[`item.systemDate`]="{ item }">
				<div>
					{{ item.sdate | moment('YYYY-MM-DD') }} ~ {{ item.edate | moment('YYYY-MM-DD') }}
					<span class="ml-2">
						{{ Math.abs($moment(item.sdate).diff($moment(item.edate), 'days')) }}
					</span>
					일간
				</div>
			</template>
			<template v-slot:[`item.reserve_btn`]="{ item }">
				<div>
					<v-btn color="primary" @click="$emit('reserve_btn', item)">
						<v-icon>mdi-check-bold</v-icon>
						지명확인
					</v-btn>
				</div>
			</template>
			<template v-slot:[`item.reserve_pass`]="{ item }">
				<div>
					<v-btn color="primary" @click="$emit('reserve_pass', item)">
						고객 패스
					</v-btn>
				</div>
			</template>
			<template v-slot:[`item.reserveday`]="{ item }">
				<div>
					{{ item.reservedays.map(x => x.title).join(', ') }}
				</div>
			</template>
			<template v-slot:[`item.range`]="{ item }">
				<div v-if="item.reservedays.length > 0">
					{{ item.reservedays[0].sdate | moment('YYYY-MM-DD') }} ~ {{ item.reservedays[0].edate | moment('YYYY-MM-DD') }}
				</div>
			</template>
			<template v-slot:[`item.check_waiting`]="{ item }">
				<div>
					<v-btn color="primary" icon @click="$emit('check_waiting', item)">
						<v-icon>mdi-check-bold</v-icon>
					</v-btn>
				</div>
			</template>
			<template v-slot:[`item.counselor_photo`]="{ item }">
				<div v-if="item.counselor_photo">
					<v-btn color="primary" icon @click="$emit('click_photo', item.counselor_photo)">
						<v-icon>mdi-file-check </v-icon>
					</v-btn>
				</div>
			</template>
			<template v-slot:[`item.range_camapign`]="{ item }">
				<div>
					{{ item.range_camapign }}
				</div>
			</template>
			<template v-slot:[`item.reserve_page_status`]="{ item }">
				<div>
					<v-btn color="MainColor1" x-small v-if="!item.custlikeApply" dark elevation="0">반영전</v-btn>
					<v-btn color="#686E73" x-small v-else dark elevation="0">완료</v-btn>
				</div>
			</template>
			<template v-slot:[`item.custlike`]="{ item }">
				<div>
					{{ item.custlike ? item.custlike : '-' }}
				</div>
			</template>
			<template v-slot:[`item.businesses_title`]="{ item }">
				<div>
					{{ item.businesses.map(x => x.title).join(', ') }}
				</div>
			</template>
			<template v-slot:[`item.history_length`]="{ item }">
				<div>{{ item.history ? item.history.length - 1 : '0' }}건</div>
			</template>
			<template v-slot:[`item.showing`]="{ item }">
				<div>
					{{ item.show ? '사용' : '미사용' }}
				</div>
			</template>
			<template v-slot:[`item.user_name`]="{ item }">
				<div>
					{{ item.name }}
				</div>
			</template>

			<template v-slot:[`item.created_at_time`]="{ item }">
				<div>
					{{ item.created_at | moment('YYYY-MM-DD HH:mm') }}
				</div>
			</template>
			<template v-slot:[`item.updated_at_time`]="{ item }">
				<div>
					{{ item.updated_at | moment('YYYY-MM-DD HH:mm') }}
				</div>
			</template>
			<template v-slot:[`item.created_at`]="{ item }">
				<div>
					{{ item.created_at | moment('YYYY-MM-DD') }}
				</div>
			</template>
			<template v-slot:[`item.updated_at`]="{ item }">
				<div>
					{{ item.updated_at | moment('YYYY-MM-DD') }}
				</div>
			</template>

			<!-- bizCounselor -->
			<!-- <template v-slot:[`item.name`]="{ item }">
				<v-layout class="nomal-input px-2" style=" max-width:200px !important; border:none !important;">
					<div class="bizInput">
						<v-text-field
							maxlength="255"
							v-model="item.name"
							:hide-details="true"
							:outlined="true"
							type="text"
							:autofocus="true"
							:autocomplete="true"
							placeholder="상담사명"
							dense
						>
						</v-text-field>
					</div>
				</v-layout>
			</template> -->
			<!-- bizCounselor -->
			<template v-slot:[`item.seat`]="{ item }">
				<v-layout class="nomal-input px-2" style=" max-width:200px !important; border:none !important;">
					<div class="bizInput">
						<v-text-field
							v-model="item.seat"
							:hide-details="true"
							:outlined="true"
							type="Number"
							:autofocus="true"
							:autocomplete="true"
							placeholder="상담석"
							dense
							:max="99"
							:oninput="
								99
									? 'if(Number(this.value) > Number(this.max)) this.value = this.max'
									: 'if(Number(this.value) > Number(this.max)) this.value = null'
							"
						>
						</v-text-field>
					</div>
				</v-layout>
			</template>
			<!-- bizCounselor -->
			<!-- <template v-slot:[`item.counselorid`]="{ item }">
				<v-layout class="nomal-input px-2" style=" max-width:200px !important; border:none !important;">
					<div class="bizInput">
						<v-text-field
							maxlength="255"
							v-model="item.counselorid"
							:hide-details="true"
							:outlined="true"
							type="text"
							:autofocus="true"
							:autocomplete="true"
							placeholder="아이디"
							dense
						>
						</v-text-field>
					</div>
				</v-layout>
			</template> -->
			<!-- bizCounselor -->
			<!-- bizCounselor -->
			<template v-slot:[`item.actionCounselor`]="{ item, index }">
				<v-layout justify-center>
					<div>
						<v-btn @click="apply(item, index)" class="mx-2 applyBtn" color="#F3F3FF" size="small" height="27" elevation="0">적용</v-btn>
					</div>
				</v-layout>
			</template>

			<!-- img FIle -->
			<template v-slot:[`item.imgUpload`]="{ item }">
				<v-layout style="height:38;px " justify-center>
					<div v-for="(img, i) in item.imgUpload" :key="i" class="mr-2">
						<v-img width="40" :src="img" @click="showUsesImg(item.imgUpload)"></v-img>
					</div>
				</v-layout>
			</template>

			<!-- stat -->
			<template v-slot:[`item.stat`]="{ item }">
				<div
					v-if="$route.name == 'counselor-management' && item.stat == false"
					:class="item.stat == false ? ['dt-align-set', 'font-red'] : ['dt-align-set']"
				>
					휴무
				</div>
				<div
					v-else-if="$route.name == 'counselor-management' && item.stat == true"
					:class="item.stat == true ? ['dt-align-set', 'font-green'] : ['dt-align-set']"
				>
					근무
				</div>
				<div
					v-else-if="$route.name == 'businessSiteManagement' && item.stat == false"
					:class="item.stat == false ? ['dt-align-set', 'font-red'] : ['dt-align-set']"
				>
					휴무
				</div>
				<!-- protect 상담사 관리- 상태 -->
				<div
					v-else-if="$route.name == 'businessSiteManagement' && item.stat == true && item.stat !== 1"
					:class="item.stat == true ? ['dt-align-set', 'font-green'] : ['dt-align-set']"
				>
					근무
				</div>
				<div v-else-if="$route.name === 'notification'" :class="item.stat === 0 ? 'success--text' : 'error--text'">
					{{ statText2(item.stat) }}
				</div>
				<!-- protect 알림톡 관리- 사용 -->
				<div v-else-if="$route.name === 'boardNotification'" :class="item.stat === 0 ? 'success--text' : 'error--text'">
					{{ statText2(item.stat) }}
				</div>
				<!-- <div v-else-if="$route.name == 'waiting' && item.stat === 0" :class="item.stat == 0 ? '' : ['dt-align-set']">
					상담중
				</div> -->
				<div v-else-if="($route.name == 'waiting' || $route.name == 'customerManagement') && item.stat === 0">상담 예약</div>
				<div v-else-if="($route.name == 'waiting' || $route.name == 'customerManagement') && item.stat === 1">상담중</div>
				<div
					v-else-if="($route.name == 'waiting' || $route.name == 'customerManagement') && item.stat === 2"
					:class="item.stat == 2 ? ['font-red'] : ['dt-align-set']"
				>
					미처리
				</div>
				<div
					v-else-if="($route.name == 'waiting' || $route.name == 'customerManagement') && item.stat === 9"
					:class="item.stat == 9 ? ['font-green'] : ['dt-align-set']"
				>
					상담 완료
				</div>

				<div v-else :class="item.stat === 1 ? 'success--text' : 'error--text'">
					{{ statText(item.stat) }}
				</div>
			</template>
			<!-- status -->
			<template v-slot:[`item.status`]="{ item }">
				<div
					v-if="item.status === null || item.status === 1"
					:class="item.status == null || 1 ? ['dt-align-set', 'font-green'] : ['dt-align-set']"
				>
					정상
				</div>
				<div v-if="item.status === 2" :class="item.status == 2 ? ['dt-align-set', 'font-red'] : ['dt-align-set']">
					예약취소
				</div>
			</template>
			<!-- No -->
			<template v-slot:[`item.No`]="{ index }">
				<div>
					{{ index + 1 }}
				</div>
			</template>

			<!-- 상담항목 관리 페이지 -> 순서 -->
			<template v-slot:[`item.listorder`]="{ item }">
				<div class="dt-align-set">
					{{ item.listorder }}
				</div>
			</template>

			<!-- 상담사 관리페이지 -> 권한 -->
			<template v-slot:[`item.authority`]="{ item }">
				<div class="dt-align-set">{{ authorityText(item.authority) }}</div>
			</template>
			<template v-if="$route.name === 'COUNSELORPAGE'" v-slot:[`item.rdate`]="{ item }">
				<div v-if="item.rdate">
					{{ item.rdate | moment('subtract', '18 hours', 'YYYY-MM-DD HH:mm') }}
				</div>
			</template>
			<template v-else v-slot:[`item.rdate`]="{ item }">
				<div v-if="item.rdate">
					{{ item.rdate | moment('subtract', '9 hours', 'YYYY-MM-DD HH:mm:ss') }}
				</div>
			</template>
			<template v-slot:[`item.cdate`]="{ item }">
				<div>
					{{ item.cdate | moment('subtract', '9 hours', 'YYYY-MM-DD HH:mm:ss') }}
				</div>
			</template>

			<!-- 상담사 관리페이지 -> 상담석 -->
			<!-- <template v-slot:[`item.seat`]="{ item }">
				<div class="dt-align-set">
					{{ item.seat }}
				</div>
			</template> -->

			<!-- 상담사 관리페이지 -> 상담원명 -->
			<!-- <template v-slot:[`item.name`]="{ item }">
				<div
					:style="`color:${$store.state.PointColor2}`"
					class="nameEvent"
					@click="nameClick(item)"
					v-if="$route.name === 'customer' || $route.name === 'trackingCode' || $route.name === 'waiting'"
				>
					{{ item.name }}
				</div>

				<div v-else>
					{{ item.name }}
				</div>
			</template> -->

			<!-- 방문예약 관리 관리페이지 -> 시작일 -->
			<template v-slot:[`item.sdate`]="{ item }">
				<div class="dt-align-set">
					{{ item.sdate }}
				</div>
			</template>

			<!-- 방문예약 관리 관리페이지 -> 종료일 -->
			<template v-slot:[`item.edate`]="{ item }">
				<div class="dt-align-set">
					{{ item.edate }}
				</div>
			</template>

			<!-- 방문예약 관리 관리페이지 -> 최대예약 -->
			<template v-slot:[`item.maxcount`]="{ item }">
				<div class="dt-align-set">
					{{ item.maxcount }}
				</div>
			</template>

			<!-- 방문예약 관리 관리페이지 -> 동행인원 -->
			<template v-slot:[`item.companion`]="{ item }">
				<div class="dt-align-set">
					{{ item.companion }}
				</div>
			</template>

			<!-- ---- issue --- -->
			<template v-slot:[`item.isuse`]="{ item }">
				<div class="dt-align-set" v-if="$route.name == 'campaign'">
					{{ isuseCampaign(item.isuse) }}
				</div>
				<div class="dt-align-set" v-else>
					{{ isuseText(item.isuse) }}
				</div>
			</template>
			<!-- ---- 알림톡관리 -> type --- -->
			<template v-slot:[`item.type`]="{ item }">
				<div v-if="$route.name == 'terms'">
					{{ typeTerm(item.type) }}
				</div>
				<div v-else>
					{{ typeText(item.type) }}
				</div>
			</template>
			<template v-slot:[`item.typeTerm`]="{ item }">
				<div>
					{{ typeTerm(item.type) }}
				</div>
			</template>
			<!-- ---- 등록고객 관리 -- 개인정보동의 --- -->
			<template v-slot:[`item.ispersonal`]="{ item }">
				<div class="dt-align-set">
					{{ agreeType(item.ispersonal) }}
				</div>
			</template>
			<!-- ---- 등록고객 관리 -- 마케팅동의 --- -->
			<template v-slot:[`item.ismarketing`]="{ item }">
				<div class="dt-align-set">
					{{ agreeType(item.ismarketing) }}
				</div>
			</template>
			<!-- ---- 사용자 관리-- confirmed --- -->
			<template v-slot:[`item.confirmed`]="{ item }">
				<div class="dt-align-set">
					{{ authoredType(item.confirmed) }}
				</div>
			</template>
			<!-- ---- 사용자 관리-- blocked --- -->
			<template v-slot:[`item.blocked`]="{ item }">
				<div class="dt-align-set">
					{{ authoredType(item.blocked) }}
				</div>
			</template>
			<template v-slot:[`item.mainimg`]="{ item }">
				<v-btn
					v-if="item.mainimg"
					x-small
					depressed
					dark
					:color="$store.state.PointColor2"
					@click="backServerClick($store.state.backServer, item)"
					>바로가기</v-btn
				>
			</template>
			<!-- Num -->
			<template v-slot:[`item.Num`]="{ item, index }">
				<div class="dt-align-set" v-show="!item.Num">{{ index + 1 }}</div>
			</template>
			<!-- channelList -->
			<template v-slot:[`item.collect`]="{ item }">
				<btn v-if="item.feedType === 2" :btn="collectBtn" btn_txt="Collect" @click="clickCollectBtn" />
			</template>

			<!-- logo -->
			<template v-slot:[`item.logoUrl`]="{ item }">
				<v-img style="background-color:grey;" max-height="30" max-width="40" :src="item.logoUrl" lazy-src="../assets/image.png"></v-img>
			</template>
			<!-- code -->
			<template v-slot:[`item.code`]="{ item }">
				<a :href="reserveDayHost + item.groupcode + '/' + item.code" target="_blank" v-if="$route.name === 'reservation'">
					{{ item.groupcode + '/' + item.code }}
				</a>
				<a :href="trackingCodeHost + '/myQr/' + item.code" target="_blank" v-if="$route.name === 'trackingCode'">
					{{ item.code }}
				</a>
				<a :href="reserveVisitHost + item.groupcode + '/' + item.code" target="_blank" v-if="$route.name === 'campaign'">
					{{ item.groupcode + '/' + item.code }}
				</a>
				<div v-if="$route.name === 'temperature'">
					{{ item.code }}
				</div>
				<!-- protect 방문예약관리 -  사업지 url -->
				<v-btn
					x-small
					depressed
					dark
					:color="$store.state.PointColor2"
					@click="reservedayClick(reserveDayHost, item)"
					v-if="$route.name === 'reservationManagement'"
					>바로가기</v-btn
				>
			</template>

			<template v-slot:[`item.codeDirect`]="{ item }">
				<a :href="reserveDirectHost + item.groupcode + '/' + item.code" target="_blank" v-if="$route.name === 'reservation'">
					{{ item.groupcode + '/' + item.code }}
				</a>
				<!-- protect 방문예약관리 -  다이렉트 url -->
				<v-btn
					x-small
					depressed
					dark
					:color="$store.state.PointColor2"
					@click="reservedirectClick(reserveDirectHost, item)"
					v-if="$route.name === 'reservationManagement'"
					>바로가기</v-btn
				>
			</template>
			<!-- 캠페인 url -->
			<template v-slot:[`item.campCode`]="{ item }">
				<v-btn x-small depressed dark :color="$store.state.PointColor2" @click="reservevisitClick(reserveVisitHost, item)">바로가기</v-btn>
			</template>
			<!-- enter QR -->
			<template v-slot:[`item.enterQR`]="{ item }">
				<v-btn x-small depressed dark :color="$store.state.PointColor2" @click="enterQRClick(enterQRHost, item)">바로가기</v-btn>
			</template>

			<!-- counsel QR -->
			<template v-slot:[`item.counselQR`]="{ item }">
				<v-btn x-small depressed dark :color="$store.state.PointColor2" @click="counselQRClick(counselQRHost, item)">바로가기</v-btn>
			</template>

			<!-- counsel QR -->
			<template v-slot:[`item.board`]="{ item }">
				<v-btn x-small depressed dark :color="$store.state.PointColor2" @click="boardHostClick(boardHost, item)">바로가기</v-btn>
			</template>

			<template v-slot:[`item.counseler`]="{ item }">
				<v-btn x-small depressed dark :color="$store.state.PointColor2" @click="counselerClick(counselser, item)">바로가기</v-btn>
			</template>
			<!-- image -->
			<template v-slot:[`item.image`]="{ item }">
				<v-img max-height="40" max-width="100" :src="item.image"></v-img>
			</template>

			<template v-slot:[`item.imageUrl`]="{ item }">
				<v-img max-height="40" max-width="100" :src="item.imageUrl"></v-img>
			</template>

			<template v-slot:[`item.startTime`]="{ item }">
				{{ item.startTime | moment('HH:mm') }}
			</template>

			<template v-slot:[`item.joinStatus`]="{ item }">
				<div :class="item.joinStatus === '꽝' ? '' : 'success--text'">
					{{ item.joinStatus }}
				</div>
			</template>

			<!-- action -->
			<template v-slot:[`item.action`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn
						v-if="$store.state.meData.username !== item.username"
						class="ml-2"
						small
						@click="editacskey(item)"
						dark
						:color="$store.state.PointColor2"
						depressed
						>수정</v-btn
					>
					<v-btn
						v-if="$store.state.meData.username !== item.username"
						class="ml-2"
						small
						@click="deleteacskey(item)"
						dark
						:color="$store.state.PointColor2"
						depressed
						>삭제</v-btn
					>
					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt="삭제" class="right-btn" :click="clickDeleteBtn" /> -->
				</v-layout>
			</template>
			<!-- etc -->
			<template v-slot:[`item.etc`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn class="ml-2" small @click="nameClick(item)" dark :color="$store.state.PointColor2" depressed>이력보기</v-btn>
					<!-- <v-btn class="ml-2" small @click="deleteacskey(item)" dark :color="$store.state.PointColor2" depressed>삭제</v-btn> -->
					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt=right-btn" :click="clickDeleteBtn" /> -->
				</v-layout>
			</template>
			<template v-slot:[`item.etcQR`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn
						class="ml-2"
						small
						@click=";($store.state.datatableItem = item), $emit('sendQR', $event)"
						dark
						:color="$store.state.PointColor2"
						depressed
						>QR</v-btn
					>
					<v-btn class="ml-2" small @click="nameClick(item)" dark :color="$store.state.PointColor2" depressed>이력보기</v-btn>
					<!-- <v-btn class="ml-2" small @click="deleteacskey(item)" dark :color="$store.state.PointColor2" depressed>삭제</v-btn> -->
					<v-btn class="ml-2" small @click="saveImg(item)" dark :color="$store.state.PointColor2" depressed>이미지</v-btn>
					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt=right-btn" :click="clickDeleteBtn" /> -->
				</v-layout>
			</template>
			<!-- etc1 -->
			<template v-slot:[`item.etc1`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn
						v-if="$store.state.meData.username !== item.username"
						class="ml-2"
						small
						@click="nameClick(item)"
						dark
						:color="$store.state.PointColor2"
						depressed
						>이력보기</v-btn
					>

					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt=click="clickDeleteBtn" /> -->
				</v-layout>
			</template>

			<template v-slot:[`item.actionReservationManagement`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn
						v-if="$store.state.meData.username !== item.username"
						class="ml-2"
						small
						@click="deleteacskey(item)"
						dark
						:color="$store.state.PointColor2"
						depressed
						>Delete</v-btn
					>
				</v-layout>
			</template>
			<!-- Only Edit -->
			<template v-slot:[`item.edit`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn v-if="$store.state.meData.username !== item.username" class="ml-2" small @click="editacskey(item)" depressed>Edit</v-btn>
					<selectBox3 :sel="item.sel" @change="qrChange(item), $emit('changeQR', $event)"></selectBox3>
					<btn :btn="editBtn" btn_txt="QRsend" @click=";($store.state.datatableItem = item), $emit('sendQR', $event)" />
					<!-- <btn :btn="deleteBtn" btn_txt=lickDeleteBtn" /> -->
				</v-layout>
			</template>
			<template v-slot:[`item.etc_edit`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn class="detail_etc_btn" small @click="detailClick(item)" :color="'#9A9C9B'" depressed>수정</v-btn>

					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt=click="clickDeleteBtn" /> -->
				</v-layout>
			</template>
			<!-- 시슴템 관리 - 사용자 관리 - 자세히 보기 -->
			<template v-slot:[`item.etc_detail`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn class="detail_etc_btn" small @click="detailClick(item)" :color="'#9A9C9B'" depressed>자세히 보기</v-btn>

					<!-- <btn :btn="editBtn" btn_txt="수정" :click="clickEditBtn" /> -->
					<!-- <btn :btn="deleteBtn" btn_txt=click="clickDeleteBtn" /> -->
				</v-layout>
			</template>
			<!-- 시슴템 관리 - 알림톡 관리 - 미리보기 + 자세히 보기 -->
			<template v-slot:[`item.etc_detail_preview`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<!-- <v-btn class="detail_etc_btn" small @click="previewClick(item)" :color="'#9A9C9B'" depressed>미리보기</v-btn> -->
					<v-btn class="detail_etc_btn mr-2" small @click="previewClick(item)" :color="'#9A9C9B'" depressed>미리보기</v-btn>
					<v-btn class="detail_etc_btn ml-3" small @click="detailClick(item)" :color="'#9A9C9B'" depressed>자세히 보기</v-btn>
				</v-layout>
			</template>

			<!-- 시슴템 관리 - 항목 관리 - 적용 + 항목편집 -->
			<template v-slot:[`item.etc_apply_edit`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<!-- <v-btn class="detail_etc_btn" small @click="previewClick(item)" :color="'#9A9C9B'" depressed>미리보기</v-btn> -->
					<v-btn class="detail_apply_btn mr-2" small @click="applyclick(item)" :color="'#9A9C9B'" depressed>적용</v-btn>
					<v-btn class="detail_apply_btn " small @click="detailClick(item)" :color="'#9A9C9B'" depressed>항목 편집</v-btn>
				</v-layout>
			</template>

			<!-- 시슴템 관리 - 항목 관리 - 적용 + 항목편집 -->
			<template v-slot:[`item.etc_apply`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<!-- <v-btn class="detail_etc_btn" small @click="previewClick(item)" :color="'#9A9C9B'" depressed>미리보기</v-btn> -->
					<v-btn class="detail_apply_btn mr-2" small @click="applyclick(item)" :color="'#9A9C9B'" depressed>적용</v-btn>
				</v-layout>
			</template>

			<!-- 시슴템 관리 - 항목 관리 - 적용 + 항목편집 -->
			<template v-slot:[`item.useYn`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<selectBox :sel="item.useYn" @change="change_default"></selectBox>
					<!-- <btn :btn="deleteBtn" btn_txt=lickDeleteBtn" /> -->
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 거점 캠페인 관리  - 캠페인 URL -->
			<template v-slot:[`item.campaign_url`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<!-- <v-btn class="detail_etc_btn" small @click="previewClick(item)" :color="'#9A9C9B'" depressed>미리보기</v-btn> -->
					<v-btn class="detail_etc_btn mr-2" small @click="$emit('campaign_url', item, 'QR')" :color="'#9A9C9B'" depressed>QR Code</v-btn>
					<v-btn class="detail_etc_btn mr-2" small @click="$emit('campaign_url', item, 'navigate')" :color="'#9A9C9B'" depressed
						>바로가기</v-btn
					>
					<v-btn class="detail_etc_btn " small @click="$emit('campaign_url', item, 'copy')" :color="'#9A9C9B'" depressed>URL 복사</v-btn>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 거점 캠페인 관리 - 팝업 - 유형 선택 -->
			<template v-slot:[`item.group_type`]="{ item }">
				<v-layout class="dt-align-set" justify-center style="overflow: hidden;">
					<selectBox style="min-height:unset;" :sel="item.group_type" @change="qrChange(item)"></selectBox>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 거점 캠페인 관리 - 팝업 - 그룹명 입력  -->
			<template v-slot:[`item.title_txtField`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<txtField
						class="bizInput"
						v-model="item.title_txtField.value"
						:txtField="item.title_txtField.txtfield"
						style="height:27px; margin:auto; background-color:white; border-radius:5px;"
					></txtField>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 거점 캠페인 관리 - 사용/미사용 라디오 버튼  -->
			<template v-slot:[`item.etc_capmaign`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-radio-group v-model="item.etc_capmaign" hide-details row class="campaign_radio">
						<v-radio class="mb-0" label="사용" :value="true" color="#FB9C00" :ripple="false"></v-radio>
						<v-radio class="mb-0" label="미사용" :value="false" color="#FB9C00" :ripple="false"></v-radio>
					</v-radio-group>

					<v-btn class="detail_apply_btn mr-2" small @click="$emit('applyclick', item)" :color="'#9A9C9B'" depressed>적용</v-btn>
				</v-layout>
			</template>
			<!-- 캠페인 관리 - 이벤트 관리 - 팝업 - 수량 입력  -->
			<template v-slot:[`item.number_txtField`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<txtField
						class="bizInput"
						v-model="item.number_txtField.value"
						:txtField="item.number_txtField.txtfield"
						style="height:27px; margin:auto; background-color:white; border-radius:5px;"
					></txtField>
				</v-layout>
			</template>
			<!-- 캠페인 관리 - 예약 상담 관리 - 상담예약 확인  -->
			<template v-slot:[`item.wating_check`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-layout class="dt-align-set" justify-center>
						<v-btn
							class="detail_etc_btn mr-2"
							small
							@click="$emit('reservation_page', item, 'wating_check_QR')"
							:color="'#9A9C9B'"
							depressed
							>바로가기</v-btn
						>
						<v-btn class="detail_etc_btn " small @click="$emit('reservation_page', item, 'wating_check_url')" :color="'#9A9C9B'" depressed
							>URL 복사</v-btn
						>
					</v-layout>
				</v-layout>
			</template>
			<!-- 캠페인 관리 - 예약 상담 관리 - 방문등록 확인  -->
			<template v-slot:[`item.reservation_check`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-btn
						class="detail_etc_btn mr-2"
						small
						@click="$emit('reservation_page', item, 'reservation_check_QR')"
						:color="'#9A9C9B'"
						depressed
						>바로가기</v-btn
					>
					<v-btn
						class="detail_etc_btn "
						small
						@click="$emit('reservation_page', item, 'reservation_check_url')"
						:color="'#9A9C9B'"
						depressed
						>URL 복사</v-btn
					>
				</v-layout>
			</template>
			<template v-slot:[`item.checkId`]="{ item }">
				<v-layout justify-center class="my-2">
					<v-radio-group v-model="$store.state.counselor_reserve" class="mt-0" dense hide-details>
						<v-radio :value="item.id"></v-radio>
					</v-radio-group>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 예약 상담 관리 - 상담사 화면  -->
			<template v-slot:[`item.counselor_page`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-layout class="dt-align-set" justify-center>
						<v-btn
							class="detail_etc_btn mr-2"
							small
							@click="$emit('reservation_page', item, 'counselor_page_QR')"
							:color="'#9A9C9B'"
							depressed
							>바로가기</v-btn
						>
						<v-btn class="detail_etc_btn " small @click="$emit('reservation_page', item, 'counselor_page_url')" :color="'#9A9C9B'" depressed
							>URL 복사</v-btn
						>
					</v-layout>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 예약 상담 관리 - 상담현황판 -->
			<template v-slot:[`item.waiting_board`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-layout class="dt-align-set" justify-center>
						<v-btn
							class="detail_etc_btn mr-2"
							small
							@click="$emit('reservation_page', item, 'waiting_board_QR')"
							:color="'#9A9C9B'"
							depressed
							>바로가기</v-btn
						>
						<v-btn class="detail_etc_btn " small @click="$emit('reservation_page', item, 'waiting_board_url')" :color="'#9A9C9B'" depressed
							>URL 복사</v-btn
						>
					</v-layout>
				</v-layout>
			</template>

			<!-- 캠페인 관리 - 이벤트 관리 - 이벤트 정보 -->
			<template v-slot:[`item.event_url`]="{ item }">
				<v-layout class="dt-align-set" justify-center>
					<v-layout class="dt-align-set" justify-center>
						<v-btn class="detail_etc_btn mr-2" small @click="$emit('event_page', item, 'event_url_QR')" :color="'#9A9C9B'" depressed
							>바로가기</v-btn
						>
						<v-btn class="detail_etc_btn " small @click="$emit('event_page', item, 'event_url_url')" :color="'#9A9C9B'" depressed
							>URL 복사</v-btn
						>
					</v-layout>
				</v-layout>
			</template>
		</v-data-table>

		<!--고객 관리 - 캠페인 고객 관리 - 자세히 보기 -->
		<!-- <template v-slot:[`item.etc_detail`]="{ item }">
			<v-layout class="dt-align-set" justify-center>
				<v-btn class="detail_etc_btn" small @click="detailClick(item)" :color="'#9A9C9B'" depressed>자세히 보기</v-btn>


			</v-layout>
		</template> -->

		<v-layout v-if="excelUseYn === 'true'">
			<v-btn small class="btn-style" @click="clickExport()">
				<img src="@/assets/images/excel-img2.png" />
				엑셀파일 다운로드
			</v-btn>
			<download-excel
				class="btn btn-default"
				id="excel-down"
				:data="datatable.items"
				style="display:none"
				:fields="json_fields"
				type="text/csv;charset=utf8"
				worksheet="My Worksheet"
				name="기간별 등록고객 현황.xls"
			>
			</download-excel>
		</v-layout>
	</div>
</template>

<script>
import { selectBox, selectBox3, txtField } from '@/components/index'
import downloadExcel from 'vue-json-excel'
import btn from './button'
export default {
	components: {
		btn,
		selectBox3,
		downloadExcel,
		selectBox,
		txtField,
	},
	data() {
		return {
			reserveDayHost: '',
			reserveDirectHost: '',
			reserveVisitHost: '',
			trackingCodeHost: '',
			enterQRHost: '',
			counselQRHost: '',
			boardHost: '',
			counselser: '',
			Host: '',
			selUser: {
				value: 'data1',
				items: ['data1', 'data2'],
				label: '사용자',
				outlined: true,
				hideDetail: true,
			},
			full: 100,
			// 패스워드 버튼
			password_btn: {
				color: 'white',

				width: '113',
				class: 'bold',
			},
			password_btn_txt: 'CHANGE',
			// 액션 버튼
			action_btn: {
				color: 'white',
				width: '113',
				class: 'bold',
			},
			action_btn_txt: 'DELETE',
			viewBtn: {
				class: 'whiteBtn',
			},
			collectBtn: {
				class: 'whiteBtn',
			},
			editBtn: {
				small: true,
				class: 'ml-2',
			},
			deleteBtn: {
				class: '',
			},
			json_fields: {},
		}
	},
	created() {
		this.reserveDayHost = location.protocol + '//' + location.host + '/reserve_day/'
		this.reserveDirectHost = location.protocol + '//' + location.host + '/reserve_direct/'
		this.reserveVisitHost = location.protocol + '//' + location.host + '/reserve_visit/'
		this.trackingCodeHost = location.protocol + '//' + location.host
		this.enterQRHost = location.protocol + '//' + location.host + '/qrReaderEnter/'
		this.counselQRHost = location.protocol + '//' + location.host + '/qrReaderCounsel/'
		this.boardHost = location.protocol + '//' + location.host + '/board/'
		this.counselser = location.protocol + '//' + location.host + '/counselorlogin/'
		this.Host = location.protocol + '//' + location.host
	},
	watch: {
		datatable() {
			let obj = {}
			if (this.datatable.headers.length > 0) {
				for (let i = 0; i < this.datatable.headers.length; i++) {
					obj[this.datatable.headers[i].text] = this.datatable.headers[i].value
				}
			}

			this.json_fields = obj
		},
	},
	methods: {
		backServerClick(backServer, item) {
			window.open(backServer + item.mainimg.url)
		},
		boardHostClick(boardHost, item) {
			window.open(boardHost + item.groupcode + '/' + item.code)
		},
		counselQRClick(counselQRHost, item) {
			window.open(counselQRHost + item.groupcode + '/' + item.code)
		},
		enterQRClick(enterQRHost, item) {
			window.open(enterQRHost + item.groupcode + '/' + item.code)
		},
		counselerClick(counselser, item) {
			window.open(counselser + item.groupcode + '/' + item.code)
		},
		reservedayClick(reserveDayHost, item) {
			window.open(reserveDayHost + item.groupcode + '/' + item.code)
		},
		reservedirectClick(reserveDirectHost, item) {
			window.open(reserveDirectHost + item.groupcode + '/' + item.code)
		},
		reservevisitClick(reserveVisitHost, item) {
			window.open(process.env.VUE_APP_CUSTOMER_URL + '/reserve_visit/' + item.groupcode + '/' + item.code)
		},
		accessChange(val, accessPermission) {
			const data = {
				acskey: val.acskey,
				state: accessPermission ? 1 : 2,
			}
			this.$store
				.dispatch('updateAdmin', data)
				.then(() => {})
				.catch(() => {})
		},
		statText(data) {
			if (data === 1) {
				return '공개'
			} else if (data === 2) {
				return '비공개'
			}
		},
		statText2(data) {
			if (data === 0) {
				return '사용'
			} else if (data === 1) {
				return '미사용'
			}
		},
		authorityText(data) {
			if (data === '0') {
				return '분양소장'
			} else if (data === '1') {
				return '상담사'
			}
		},
		isuseText(data) {
			if (data === 0) {
				return '운영중'
			} else if (data === 1) {
				return '휴관'
			} else if (data === 2) {
				return '종료'
			}
		},

		isuseCampaign(data) {
			if (data === 1) {
				return 'Y'
			} else if (data === 2) {
				return 'N'
			}
		},
		typeText(data) {
			if (data === 1) {
				return '신청완료'
			} else if (data === 2) {
				return '내앞대기수'
			} else if (data === 3) {
				return '대기'
			} else if (data === 4) {
				return '상담석'
			} else if (data === 5) {
				return '미처리'
			} else if (data === 6) {
				return '방문예약취소'
			}
		},
		typeTerm(data) {
			if (data === 1) {
				return '개인정보 수집 동의'
			} else if (data === 2) {
				return '마케팅 활용 동의'
			} else if (data === 3) {
				return '미동의'
			}
		},
		agreeType(data) {
			if (data === 1) {
				return 'Y'
			} else if (data === 2) {
				return 'N'
			}
		},
		authoredType(data) {
			if (data) {
				return 'Y'
			} else if (!data) {
				return 'N'
			}
		},
		apply(item, index) {
			item.index = index
			this.$store.state.datatableItem = item
			this.applyclick()
		},
		pwchange(item) {
			this.$store.state.datatableItem = item
			this.passwordclick()
		},
		saveImg(item) {
			this.$store.state.datatableItem = item
			this.saveImgBtn()
		},
		deleteacskey(item) {
			this.$store.state.datatableItem = item
			this.clickDeleteBtn()
		},
		editacskey(item) {
			this.$store.state.datatableItem = item
			this.datatable.noweditting = this.datatable.items.indexOf(item)
			this.clickEditBtn()
		},
		nameClick(item) {
			this.$store.state.datatableItem = item
			this.datatable.noweditting = this.datatable.items.indexOf(item)
			this.clickName()
		},
		roleTypeText(data) {
			if (data === 'ROLE_SUPER_ADMIN') {
				return 'Super Admin'
			} else if (data === 'ROLE_ADMIN') {
				return 'Admin'
			} else if (data === 'ROLE_USER') {
				return 'CP member'
			} else {
				return 'No Role'
			}
		},
		setIndexNum(id) {
			this.datatable.setIndex = this.datatable.items.map(v => v.userId).indexOf(id)
		},
		showUsesImg(img) {
			this.$store.commit('usersImg', img)
			this.imgDialogShow()
		},
		qrChange() {},
		clickExport() {
			document.getElementById('excel-down').click()
		},
		change_default() {},
	},
	props: {
		search: String,
		clickrow: Function,
		userheaderselect: Object,
		datatable: Object,
		clickViewBtn: Function,
		passwordclick: Function,
		applyclick: Function,
		clickDeleteBtn: Function,
		saveImgBtn: Function,
		clickEditBtn: Function,
		clickName: Function,
		changeUser: Function,
		clickCollectBtn: Function,
		imgDialogShow: Function,
		detailClick: Function,
		previewClick: Function,
		excelUseYn: String,
	},
}
</script>

<style lang="scss">
.text-start {
	text-align: center !important;
}
.noSort {
	th {
		height: 0px !important;
	}
}
.dt-align-set {
	margin-left: -16px;
	text-align: center;
}
.OkBtn {
	cursor: pointer;
	text-decoration: underline;
}
.max-width-table .v-data-table__wrapper {
	th {
		width: 120px !important;
		max-width: 120px !important;
	}
	td {
		overflow: auto;
	}
	margin-top: 20px;
}
.datatablehover .v-data-table__wrapper {
	td {
		overflow: auto;
	}
	margin-top: 20px;
}
.cursorDefalut .v-data-table__wrapper {
	td {
		cursor: default;
	}
}
.overflow_common {
	overflow: auto;
}
.datatablehover .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
	cursor: pointer !important;
	// background-color: #d1d1d1 !important;
}
.action_btn,
.password_btn {
	border: 1px solid #d1d1d1;
	border-radius: 5px 5px 5px 5px;
	font-weight: bold;
}
.whiteBtn {
	border: 1px solid #d1d1d1 !important;
	background-color: white !important;
	border-radius: 5px;
	font-weight: bold;
	width: 100px;
	height: 36px;
}
.font-green {
	color: #4caf50;
}
.font-red {
	color: #ff5252;
}
.nameEvent {
	// color: #fdc85a;
	cursor: pointer !important;
	text-decoration: underline;
}
.datatablehover > .v-data-table > .v-data-table__wrapper > table {
	border-right: 1px solid #d1d1d1;
	border-left: 1px solid #d1d1d1;
	thead {
		background-color: #f5f5f5 !important;
		border-top: 1px solid #323153;

		tr {
			th:not(:last-of-type) {
				border-right: 1px solid #d1d1d1;
			}
			th {
				text-align: center !important;
				color: #333333;
				height: 53px;
			}
		}
	}
}

.datatablehover > .v-data-table > .v-data-table__wrapper > table {
	tbody {
		tr {
			td:not(:last-of-type) {
				border-right: 1px solid #d1d1d1;
			}
			td {
				height: 36px;
				text-align: center !important;
			}
		}
	}
}
.datatablehover > .v-data-table > .v-data-table__wrapper > table {
	tbody {
		tr:hover {
			background-color: #ffd999 !important;
		}
	}
}
.datatablehover > .v-data-table > .v-data-footer {
	justify-content: end;
	padding-right: 200px;
}
.datatablehover2 > .v-data-table > .v-data-footer {
	justify-content: end;
	padding-right: 0px;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select {
	// color: #e89000;
	font-weight: bold;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div {
	border: 1px solid #c5c5c5;
	border-radius: 5px;
	padding: 0 5px 0 10px;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div > div > div::before {
	border: none;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div > div > div {
	border: none;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div > div > div > .v-menu {
	border: none;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div > div > div > .v-menu::after {
	border: none;
}
.datatablehover > .v-data-table > .v-data-footer > .v-data-footer__select > div > div > div > div > .v-select__selections {
	width: 20px;
}
.btn-style {
	box-shadow: none;
	background-color: #ffffff;
	border: 1px solid #9a9c9b;
	border-radius: 5px;
	// margin-top: -3rem !important;
	// margin-left: 92.5rem !important;
	position: absolute;
	bottom: 15px;
	right: 5px;
}
.customer_dialog_table .v-data-table--fixed-header > div > table > thead > tr > th {
	background: #f5f5f5 !important;
	height: 53px;
}
</style>
